import ApplicationsWrapper from '../../../ApplicationsWrapper';
import AcceptZillowApplicationsFieldSet from './AcceptZillowApplicationsFieldSet';

import type { TRIGGER_LOCATIONS } from '../../../../constants/ClickstreamConstants';

type Props = {
  triggerLocation?: (typeof TRIGGER_LOCATIONS)[keyof typeof TRIGGER_LOCATIONS];
};

const AcceptApplicationsContentWithFields = ({ triggerLocation }: Props) => {
  return (
    <ApplicationsWrapper>
      <AcceptZillowApplicationsFieldSet triggerLocation={triggerLocation} />
    </ApplicationsWrapper>
  );
};

export default AcceptApplicationsContentWithFields;
